module.exports = __webpack_public_path__ + "static/media/logo.88ae3d94.svg";